<template>
  <div class="add-person">
    <div class="add-person-list">
      <div class="add-person-item" v-for="(item, i) in list" :key="item.id">
        <a-icon class="add-person-icon" type="user" />
        <div class="add-person-name">{{item.name}}<span class="add-person-mobile">{{item.mobile}}</span></div>
        <a-icon type="close" class="add-person-operate" @click="removePerson(i)"/>
      </div>
      <a-tooltip v-show="!edit">
        <template slot="title">添加人员</template>
        <a-button size="small" shape="circle" type="primary" icon="plus" class="add-person-btn" @click="showAddPerson"/>
      </a-tooltip>
    </div>
    <a-form-model ref="personForm" layout="inline" :model="form" :rules="rules" v-show="edit">
      <a-form-model-item label="" prop="name">
        <a-input v-model="form.name" placeholder="请输入姓名" />
      </a-form-model-item>
      <a-form-model-item label="" prop="mobile">
        <a-input v-model="form.mobile" placeholder="请输入手机号码" />
      </a-form-model-item>
      <a-form-model-item>
        <a-button @click="cancelAdd">取消</a-button>
        <a-button style="margin-left: 10px;" type="primary" @click="confirmAdd">确定</a-button>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
    import {MOBILE_REG, generateRegExpValidator} from "../../common/constant/formItems";

    export default {
        name: "add-person",
        model: {
            event: "change"
        },
        props: {
            value: Array,
        },
        data() {
            return {
                form: {},
                rules: {
                    name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                    mobile: [
                        { required: true, message: '请输入手机号码', trigger: 'blur' },
                        { validator: generateRegExpValidator(new RegExp((MOBILE_REG)), "请输入正确的手机号码"), trigger: 'blur' }
                    ],
                },
                edit: false,
            }
        },
        computed: {
            list: {
                get() {
                    return this.value ? [...this.value] : []
                },
                set(val) {
                    console.log(val);
                    this.$emit("change", val.length > 0 ? val : null);
                }
            },
        },
        methods: {
            removePerson(i) {
                const list = [...this.list];
                list.splice(i, 1);
                this.list = list;
            },
            showAddPerson() {
                this.edit = true;
            },
            confirmAdd() {
                this.$refs.personForm.validate(valid => {
                    if (valid) {
                        this.list = [...this.list, {...this.form}];
                        this.cancelAdd();
                    }
                });
            },
            cancelAdd() {
                this.form = {};
                this.edit = false;
            },
        }
    }
</script>

<style lang="less">
  .add-person {
    padding: 4px 0;
  }
  .add-person-btn {
    margin: 6px 0;
  }
  .add-person-list {
    display: flex;
    flex-wrap: wrap;
  }
  .add-person-item {
    display: flex;
    align-items: center;
    margin: 0 0.5em 0.5em 0;
    padding: 0 6px;
    height: 32px;
    border-radius: 2px;
    border: 1px solid #E4E6E9;
    .add-person-icon,
    .add-person-operate {
      font-size: 16px;
      color: @primary-color;
    }
  }
  .add-person-operate,
  .add-person-name {
    margin-left: 8px;
  }
  .add-person-mobile {
    margin-left: 6px;
    color: @text-color-secondary;
  }

</style>
